import { getTermValue, TJsonQueryKeys } from '../../../../JsonQuery';
import { IJsonQuery } from '../../types/jsonQuery';
import { COMMON_PROPERTIES, COMMON_PROPERTIES_SUBURBAN, RENTAL_PERIOD_SELECTED_OPTIONS } from './constants';

function isCommonPropertiesSelected(jsonQuery: IJsonQuery) {
  if (jsonQuery._type === 'suburbansale') {
    return (Object.keys(jsonQuery) as TJsonQueryKeys[]).some(
      property => !COMMON_PROPERTIES_SUBURBAN.includes(property) && jsonQuery[property] !== undefined,
    );
  }

  return (Object.keys(jsonQuery) as TJsonQueryKeys[]).some(
    property => !COMMON_PROPERTIES.includes(property) && jsonQuery[property] !== undefined,
  );
}

function isRentalPeriodSelected(jsonQuery: IJsonQuery) {
  const rentalPeriod = getTermValue('for_day')(jsonQuery);

  return rentalPeriod !== null && RENTAL_PERIOD_SELECTED_OPTIONS.includes(rentalPeriod);
}

export function isAdvancedFiltersSelected(jsonQuery: IJsonQuery): boolean {
  return isCommonPropertiesSelected(jsonQuery) || isRentalPeriodSelected(jsonQuery);
}
